// extracted by mini-css-extract-plugin
export default {"current":"bs_gD","update":"bs_gF","showColors":"bs_gG","positive":"bs_gB","negative":"bs_gC"};